import React, { useState } from "react";
import { ethers } from "ethers";

const DexSwapForm = ({ provider, account }) => {
    const [fromToken, setFromToken] = useState("KAI");
    const [toToken, setToToken] = useState("GOLD");
    const [amount, setAmount] = useState("");
    const [txHash, setTxHash] = useState("");
    const [usedAmount, setUsedAmount] = useState("");

    const dexAddress = process.env.REACT_APP_DEX_ADDRESS;
    const goldAddress = process.env.REACT_APP_GOLD_ADDRESS;
    const silverAddress = process.env.REACT_APP_SILVER_ADDRESS;

    const ERC20_ABI = [
        "function approve(address, uint256) public returns (bool)"
    ];

    const handleSwap = async () => {
        if (!provider || !account || !amount) return;
        const signer = await provider.getSigner();
        const dex = new ethers.Contract(
            dexAddress,
            [
                "function swapKaiaToGold() payable",
                "function swapKaiaToSilver() payable",
                "function swapGoldToSilver(uint256)",
                "function swapSilverToGold(uint256)",
                "function swapGoldToKaia(uint256)",
            ],
            signer
        );

        try {
            let tx;
            const parsedAmount = ethers.parseEther(amount);

            if (fromToken === "KAI" && toToken === "GOLD") {
                tx = await dex.swapKaiaToGold({ value: parsedAmount });
            } else if (fromToken === "KAI" && toToken === "SILVER") {
                tx = await dex.swapKaiaToSilver({ value: parsedAmount });
            } else if (fromToken === "GOLD" && toToken === "SILVER") {
                const gold = new ethers.Contract(goldAddress, ERC20_ABI, signer);
                await gold.approve(dexAddress, parsedAmount);
                tx = await dex.swapGoldToSilver(parsedAmount);
            } else if (fromToken === "SILVER" && toToken === "GOLD") {
                const silver = new ethers.Contract(silverAddress, ERC20_ABI, signer);
                await silver.approve(dexAddress, parsedAmount);
                tx = await dex.swapSilverToGold(parsedAmount);
            } else if (fromToken === "GOLD" && toToken === "KAI") {
                const gold = new ethers.Contract(goldAddress, ERC20_ABI, signer);
                await gold.approve(dexAddress, parsedAmount);
                tx = await dex.swapGoldToKaia(parsedAmount);
            } else {
                alert("해당 스왑 경로는 지원하지 않습니다.");
                return;
            }

            const receipt = await tx.wait();
            setTxHash(receipt.hash);
            setUsedAmount(amount);
        } catch (err) {
            console.error(err);
            alert("트랜잭션 실패");
        }
    };

    return (
        <div>
            <h3>토큰 스왑</h3>
            <div>
                <label>바꿀 토큰:</label>
                <select value={fromToken} onChange={(e) => setFromToken(e.target.value)}>
                    <option value="KAI">Kaia</option>
                    <option value="GOLD">Gold</option>
                    <option value="SILVER">Silver</option>
                </select>
            </div>
            <div>
                <label>받을 토큰:</label>
                <select value={toToken} onChange={(e) => setToToken(e.target.value)}>
                    <option value="KAI">Kaia</option>
                    <option value="GOLD">Gold</option>
                    <option value="SILVER">Silver</option>
                </select>
            </div>
            <input
                placeholder="스왑 수량"
                value={amount}
                onChange={(e) => setAmount(e.target.value)}
            />
            <button onClick={handleSwap}>교환</button>

            {txHash && (
                <div>
                    <p>사용된 수량: {usedAmount}</p>
                    <p>트랜잭션 해시: {txHash}</p>
                </div>
            )}
        </div>
    );
};

export default DexSwapForm;
